export default __webpack_public_path__ + "static/media/1611047_ZR_003_Vicki_Holt.2dca9e71.jpg";